import { getWeekList } from '@/utils/time';
import { statsFieldPack as sfp } from '@/constants/statsFieldPack';
/** 상점 요일별 통계 엔티티 */
export default class StatsStoreDayOfWeek {
    /** 아이디 */
    id = 0;
    /** 허브 이름 */
    hubName = '';
    /** 상점 이름 */
    storeName = '';
    constructor(_data = {}) {
        getWeekList().forEach((week) => {
            this[`${sfp.completed.key}_${week.value}`] = 0;
            this[`${sfp.ratio.key}_${week.value}`] = 0;
        });
        Object.assign(this, _data);
    }
}
